import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import type {
  ComplianceDocumentI18nNamespace,
  ComplianceDocumentTranslationKeyPrefix,
} from './complianceDocumentEditorTypes'

type OutstandingCalloutNavigatorProps = {
  count: number
  isGenerating: boolean
  translationKeyPrefix: ComplianceDocumentTranslationKeyPrefix
  i18nNamespace: ComplianceDocumentI18nNamespace
  onPrevious: () => void
  onNext: () => void
}

export function OutstandingCalloutNavigator({
  count,
  isGenerating,
  translationKeyPrefix,
  i18nNamespace,
  onPrevious,
  onNext,
}: OutstandingCalloutNavigatorProps) {
  const { t } = useTranslation(i18nNamespace)
  const baseKey = `${translationKeyPrefix}.outstandingCallouts`
  const navigationDisabled = count === 0 || isGenerating

  let countLabel = t(`${baseKey}.noneRemaining`)
  if (count === 1) {
    countLabel = t(`${baseKey}.oneRemaining`)
  }
  if (count > 1) {
    countLabel = t(`${baseKey}.manyRemaining`, { count })
  }

  return (
    <div className='flex flex-wrap items-center justify-end gap-2'>
      <p className='text-muted-foreground text-sm'>{countLabel}</p>
      <div className='flex items-center gap-1'>
        <Button
          type='button'
          size='sm'
          variant='outline'
          disabled={navigationDisabled}
          aria-label={t(`${baseKey}.previousAria`)}
          onClick={onPrevious}
        >
          <ChevronLeft className='size-4' />
        </Button>
        <Button
          type='button'
          size='sm'
          variant='outline'
          disabled={navigationDisabled}
          aria-label={t(`${baseKey}.nextAria`)}
          onClick={onNext}
        >
          <ChevronRight className='size-4' />
        </Button>
      </div>
    </div>
  )
}
